export enum BillingCodes {
	TIME_OFF = 436,
	ON_CALL = 437
}



// WEBPACK FOOTER //
// ./src/app/shared/billing-codes.enum.ts